import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "wrapper"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Next ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Form, {
          as: "el-form",
          onSubmit: _ctx.nextStep
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              modelValue: _ctx.professionDetailValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.professionDetailValue) = $event)),
              name: "professionDetail",
              label: "Specialty",
              placeholder: "Specialty?",
              options: _ctx.professionDetailList,
              filterable: ""
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_app_button, {
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              disabled: _ctx.professionDetailValue === undefined,
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.provider.button')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_Form, {
          as: "el-form",
          onSubmit: _ctx.nextStep
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              modelValue: _ctx.professionDetailValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.professionDetailValue) = $event)),
              name: "professionDetail",
              label: "Specialty",
              placeholder: "Specialty?",
              options: _ctx.professionDetailList
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_app_button, {
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              disabled: _ctx.professionDetailValue === undefined,
              round: ""
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]))
}